import {
  isActionVisibleOnDashboard,
  isActionCompleted,
  isActionDisabledByDate,
  type Action,
} from "@core/features/actions";
import { ActionListCard } from "@themes/pollinator/ui/ActionListCard";
import { ProgramPhaseActionItemContainer } from "@platform/features/programPhases/components/PhaseAction";

export type Props = {
  actions: Action[];
  organizationName: string;
};

export function OrgAdminActionList({ actions, organizationName }: Props) {
  const visibleActions = actions?.filter(isActionVisibleOnDashboard);
  const completedCount = visibleActions?.filter(isActionCompleted).length ?? 0;
  const totalCount = visibleActions?.length ?? 0;

  if (totalCount === 0) {
    return null;
  }

  return (
    <ActionListCard
      title={organizationName}
      completedCount={completedCount}
      totalCount={totalCount}
    >
      {visibleActions?.map((action, idx) => (
        <ProgramPhaseActionItemContainer
          key={`${action.name}-${idx}`}
          disabled={isActionDisabledByDate(action)}
          action={action}
        />
      ))}
    </ActionListCard>
  );
}

export default OrgAdminActionList;
